import { lazy } from 'react';

// project imports
import Loadable from '../components/ui-component/Loadable';
import MinimalLayout from '../layouts/MinimalLayout/index';
import { Navigate } from 'react-router-dom';

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('../views/authentication/authentication3/Login3')));
const AuthRegister3 = Loadable(lazy(() => import('../views/authentication/authentication3/Register3')));
const PromoCheckPage = Loadable(lazy(() => import('../views/promo/PromoCheckPage')));
const AmoDealsSearchPage = Loadable(lazy(() => import('../views/amo-rules-page/amo-deals-search-page.jsx')));
//* OTHER PAGES

const NotFoundPage = Loadable(lazy(() => import('../views/not_found/not_found.view')));
const SuccessPage = Loadable(lazy(() => import('../views/statuses/success')));
const ErrorPage = Loadable(lazy(() => import('../views/statuses/error')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

/*****Routes******/

const AuthenticationRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/',
      element: <Navigate to='/promo' replace />,
    },
    {
      path: '/login',
      element: <AuthLogin3 />,
    },
    {
      path: '/register',
      element: <AuthRegister3 />,
    },
    {
      path: 'promo',
      element: <PromoCheckPage />,
    },
    {
      path: 'amo/deals-search',
      element: <AmoDealsSearchPage />,
    },
    {
      path: 'widget/sended',
      element: <SuccessPage />,
    },
    {
      path: 'widget/error',
      element: <ErrorPage />,
    },
    {
      path: '*',
      element: <NotFoundPage />,
    },
  ],
};

export default AuthenticationRoutes;
